import { useState, useEffect } from 'react'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/common/ui/alert-dialog'

interface ProviderResolutionConflictDialogProps {
	isOpen: boolean
	onClose: () => void
	message: string
}

export function ProviderResolutionConflictDialog({
	isOpen,
	onClose,
	message,
}: ProviderResolutionConflictDialogProps) {
	const [isMounted, setIsMounted] = useState(false)

	useEffect(() => {
		setIsMounted(true)
	}, [])

	if (!isMounted) {
		return null
	}

	return (
		<AlertDialog open={isOpen} onOpenChange={onClose}>
			<AlertDialogContent className="max-w-2xl">
				<AlertDialogHeader>
					<AlertDialogTitle className="flex items-center gap-2 text-destructive">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							className="h-6 w-6"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
							/>
						</svg>
						ข้อผิดพลาด: ความขัดแย้งในการตั้งค่าผู้ให้บริการเกม
					</AlertDialogTitle>
					<AlertDialogDescription className="space-y-4 text-left">
						<div className="rounded-lg border border-destructive/50 bg-destructive/10 p-4">
							<p className="text-base text-foreground">{message}</p>
						</div>

						<div className="space-y-2">
							<h4 className="font-semibold text-foreground">
								ทำไมการตั้งค่านี้ไม่ได้รับอนุญาต?
							</h4>
							<p className="text-sm text-muted-foreground">
								เวอร์ชั่นที่ใช้ Hard หรือ
								แท้ต้องสอดคล้องกับค่ายที่เข้าร่วมรายการ เช่นเลือกเวอร์ชั่น
								PGHARD ควรเลือกค่าย PGHARD ในรายการที่เข้าร่วมรายการ
							</p>
						</div>
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogAction onClick={onClose}>เข้าใจแล้ว</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
